module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_0.d9979dd2.png";